import React from 'react';
import { accent } from '../utils/colors';

const tabs = [
  { id: 'skills', label: 'Навыки' },
  { id: 'matrix', label: 'Матрица' },
  { id: 'grades', label: 'Грейды' },
  { id: 'board', label: 'Доска' },
];

export default function TopNav({ current }) {
  return (
    <div style={{ display: 'flex', gap: 10, justifyContent: 'center', padding: '10px 12px' }}>
      {tabs.map(t => {
        const active = current === t.id;
        return (
          <a
            key={t.id}
            href={`#/${t.id}`}
            style={{
              textDecoration: 'none',
              background: active ? accent : '#fff',
              color: active ? '#fff' : accent,
              border: `1.5px solid ${accent}`,
              borderRadius: 8,
              padding: '8px 14px',
              fontWeight: 700,
              boxShadow: active ? '0 2px 8px #a259f744' : 'none',
            }}
          >
            {t.label}
          </a>
        );
      })}
    </div>
  );
}

